import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

function CardItem({ card }) {
  return (
    <div className="casino-result-cards-item">
      <img src={getCardImage(card)} alt="" />
    </div>
  );
}

function OpenItem({ title, titleClass, cards, isWinner }) {
  return (
    <div className="casino-open-result-item">
      <h4 className={titleClass}>{title}</h4>{" "}
      <div className="casino-result-cards">
        <div className="casino-result-cards-item-container">
          {cards.map((c, i) => (
            <React.Fragment key={i}>
              {i > 0 && " "}
              <CardItem card={c} />
            </React.Fragment>
          ))}{" "}
          {isWinner && (
            <div className="casino-result-cards-item">
              <img src={WINNER_IMG} className="winner-icon" alt="" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/**
 * Reference result body for Teenpatti Open (teen8): player s cards [s-1, s+8, s+17] (+ trophy when
 * s is in win "1,2,..."), dealer D cards [8, 17, 26]; rdesc "winner#pairplus#total~total~dealer#".
 */
export default function Teen8ResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim());
  const winners = t1?.win ? String(t1.win).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const total = String(desc[2] || "").split("~");

  return (
    <div className="row row5 casino-open">
      <div className="col-12 col-lg-7">
        <div className="casino-open-result">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((s) => (
            <OpenItem
              key={s}
              title={s}
              cards={[cards[s - 1], cards[s + 8], cards[s + 17]]}
              isWinner={winners.indexOf(String(s)) !== -1}
            />
          ))}{" "}
          <OpenItem title="D" titleClass="text-warning" cards={[cards[8], cards[17], cards[26]]} />
        </div>
      </div>{" "}
      <div className="col-12 col-lg-5">
        {desc.length ? (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Pair Plus</div> <div>{desc[1]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Total</div> <div>{total[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div /> <div>{total[1]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div /> <div>{total[2]}</div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
